import { createBuilder, createSchema, defineMutators, defineQueries, } from "@rocicorp/zero";
import { equipmentPlanMutatorDefinitions, equipmentPlanQueryDefinitions, equipmentPlanRelationships, equipmentDomainDescriptions, equipmentPlanTables, functionAssignmentRelationships as equipmentFunctionAssignmentRelationships, } from "./equipment-plan.js";
import { projectDomainDescriptions, projectMutatorDefinitions, projectQueryDefinitions, projectRelationshipsList, projectTables, } from "./projects.js";
import { vehicleDomainDescriptions, vehicleMutatorDefinitions, vehicleQueryDefinitions, vehicleRelationshipsList, vehicleTables, } from "./vehicles.js";
const appTables = [
    ...equipmentPlanTables,
    ...projectTables.filter((table) => !equipmentPlanTables.includes(table)),
    // vehicleTables reuses the shared people and projects tables
    ...vehicleTables.filter((table) => !equipmentPlanTables.includes(table) &&
        !projectTables.includes(table)),
];
const equipmentRelationshipsForApp = equipmentPlanRelationships.filter((relationship) => relationship !== equipmentFunctionAssignmentRelationships);
const appRelationships = [
    ...equipmentRelationshipsForApp,
    ...projectRelationshipsList.filter((relationship) => !equipmentRelationshipsForApp.includes(relationship)),
    ...vehicleRelationshipsList,
];
export const appSchema = createSchema({
    tables: appTables,
    relationships: appRelationships,
});
// The app combines query and mutator domains from multiple schemas. Zero's
// registry type collapses these spread dynamic domains into unions, so expose
// a callable tree at this package boundary and keep validation in each domain.
// The raw definitions keep each operation's input validator, which the
// processed registries below drop. The REST API reads them for its spec.
export const appQueryDefinitions = {
    ...equipmentPlanQueryDefinitions,
    ...projectQueryDefinitions,
    ...vehicleQueryDefinitions,
};
export const appMutatorDefinitions = {
    ...equipmentPlanMutatorDefinitions,
    ...projectMutatorDefinitions,
    ...vehicleMutatorDefinitions,
};
export const appQueries = defineQueries(appQueryDefinitions);
export const appMutators = defineMutators(appMutatorDefinitions);
export const appZql = createBuilder(appSchema);
/** One-line description per operation domain (`people`, `tasks`, ...). */
export const appDomainDescriptions = {
    ...equipmentDomainDescriptions,
    ...projectDomainDescriptions,
    ...vehicleDomainDescriptions,
};
